function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const recommend = window['@algolia/recommend'];
const {
  FrequentlyBoughtTogether,
  RelatedProducts,
  TrendingItems,
  TrendingFacets
} = window['@algolia/recommend-react'];
const recommendClient = recommend(APPLICATION_ID, API_KEY);
const indexName = INDEX_NAME;
function CompleteTheLook(props) {
  const [products, setProducts] = React.useState([]);
  const [productTags, setProductTags] = React.useState([]);
  const [dataFetched, setDataFetched] = React.useState(false);
  const [cardsFetched, setCardsFetched] = React.useState(0);
  const [showRemaining, setShowRemaining] = React.useState(false);
  const cardsCounter = () => {
    setCardsFetched(cardsFetched + 1);
    // console.log('COUNTER +1')
  };

  const handleToggleShowRemaining = () => {
    setShowRemaining(!showRemaining);
  };
  React.useEffect(() => {
    setDataFetched(false);
    const endpoint = 'https://tlfapparel.myshopify.com/api/2023-01/graphql.json';
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Shopify-Storefront-Access-Token': '239f5284842448954ceaeb9e81a967b4'
    });
    const getCTLProducts = async () => {
      const query = () => `{
      product(handle: "${props.Producthandle}") {
        tags
        CTL: metafield(namespace: "custom", key: "complete_the_look") {
          value
        }
      }
    }`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          query: query()
        })
      });
      const Collection = await response.json();
      Collection.data.product.CTL && setProducts(Collection.data.product.CTL.value.replace(/]|\[|\"/g, "").split(","));
      Collection.data.product.tags && setProductTags(Collection.data.product.tags);
      setDataFetched(true);
    };
    getCTLProducts();
  }, [props.Producthandle]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, dataFetched && /*#__PURE__*/React.createElement("div", {
    className: "upsellSection"
  }, /*#__PURE__*/React.createElement("div", {
    className: "largeThinText"
  }, "COMPLETE THE LOOK"), products[0] && /*#__PURE__*/React.createElement(CompleteTheLookCard, {
    item: {
      id: products[0]
    },
    counter: cardsCounter
  }), cardsFetched == 0 && productTags.includes("gender:WOMENS") && /*#__PURE__*/React.createElement(CompleteTheLookCard, {
    item: {
      id: "gid://shopify/Product/7395274916036"
    }
  }), cardsFetched == 0 && productTags.includes("gender:MENS") && /*#__PURE__*/React.createElement(CompleteTheLookCard, {
    item: {
      id: "gid://shopify/Product/7395228319940"
    }
  }), showRemaining && products.slice(1).map((productID, index) => /*#__PURE__*/React.createElement(CompleteTheLookCard, {
    counter: cardsCounter,
    item: {
      id: productID
    },
    key: index
  })), cardsFetched < 2 && showRemaining && /*#__PURE__*/React.createElement("div", null, productTags.includes("gender:WOMENS") ? /*#__PURE__*/React.createElement(CompleteTheLookCard, {
    item: {
      id: "gid://shopify/Product/7369125396676"
    }
  }) : /*#__PURE__*/React.createElement(CompleteTheLookCard, {
    item: {
      id: "gid://shopify/Product/7382685810884"
    }
  })), /*#__PURE__*/React.createElement("button", {
    className: "addToBagBtn showMoreBtn",
    onClick: handleToggleShowRemaining
  }, " ", showRemaining ? 'Hide' : 'Show more')));
}
function RelatedProductsSection(props) {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [recommended, setRecommended] = React.useState(null);
  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fourSixty"
  }, /*#__PURE__*/React.createElement(FourSixtySlider, null)), /*#__PURE__*/React.createElement(RelatedProducts, {
    maxRecommendations: 4,
    recommendClient: recommendClient,
    indexName: indexName,
    objectIDs: [props.productId],
    itemComponent: itemProps => /*#__PURE__*/React.createElement(ReactProductCard, _extends({
      recommended: true
    }, itemProps, {
      windowWidth: windowWidth
    }))
  }));
}

// function FrequentlyBoughtTogetherSection(props) {
//   const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
//   const [recommended, setRecommended] = React.useState(null);

//   React.useEffect(() => {

//     function handleResize() {
//       setWindowWidth(window.innerWidth)
//     }
//     window.addEventListener('resize', handleResize)

//     return _ => {
//       window.removeEventListener('resize', handleResize)
//     }
//   }, [windowWidth]);

//   return (
//     <>
//       <FrequentlyBoughtTogether
//         recommendClient={recommendClient}
//         indexName={indexName}
//         objectIDs={[props.productTags]}
//         itemComponent={(itemProps) => <ReactProductCard2 {...itemProps} windowWidth={windowWidth} />}
//       />
//     </>
//   );
// }

const completeTheLook = document.getElementById('complete-the-look');
if (completeTheLook) {
  const completeTheLookRoot = ReactDOM.createRoot(completeTheLook);
  document.addEventListener('colorVariantChange', function (e) {
    const {
      pathname
    } = window.location;
    let handle = pathname.split('/products/')[1];
    completeTheLookRoot.render( /*#__PURE__*/React.createElement(CompleteTheLook, {
      Producthandle: handle,
      productId: completeTheLook.dataset.productId
    }));
  });
  completeTheLookRoot.render( /*#__PURE__*/React.createElement(CompleteTheLook, {
    Producthandle: completeTheLook.dataset.productHandle,
    productId: completeTheLook.dataset.productId
  }));
} else {
  console.log('#complete-the-look not found');
}
const completeTheLook2 = document.getElementById('similar-styles');
if (completeTheLook2) {
  const completeTheLook2Root = ReactDOM.createRoot(completeTheLook2);
  completeTheLook2Root.render( /*#__PURE__*/React.createElement("div", {
    className: "relatedProductsSection"
  }, /*#__PURE__*/React.createElement(RelatedProductsSection, {
    productId: completeTheLook2.dataset.productId
  })));
} else {
  console.log(' similar-styles not found');
}
